import React, { Component } from 'react';

class Store {
    constructor(state) {
        this.state = state;
        this.subscribtions = [];
    }
    subscribe(callback) {
        this.subscribtions.push(callback);
        return this.subscribtions.indexOf(callback);
    }
    unsubscribe(index) {
        delete this.subscribtions[index];
    }
    setState(extensionObject) {
        this.state = Object.assign({}, this.state, extensionObject);
        this.subscribtions.forEach(callback => (callback ? callback() : null));
    }
}

export default function connect(initialState = {}) {
    const store = new Store(initialState);

    return function connected(InnerComponent) {
        return class GlobalState extends Component {
            componentDidMount() {
                this.subscription = store.subscribe(this.handleChange.bind(this))
            }

            handleChange() {
                this.setState({ state: store.state })
            }

            render() {
                const { props } = this;
                return (
                    <InnerComponent
                        {...props}
                        {...store.state}
                        setGlobalState={ store.setState.bind(store) }
                    />
                );
            }
        };
    };
}
